"use strict";

var _objectSpread = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/objectSpread");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var v4_1 = __importDefault(require("uuid/v4"));

var RowKeyValue = __importStar(require("./rows/key-value"));

var UtilsLabel = __importStar(require("./label"));

var UtilsColumn = __importStar(require("./column"));

var row_type_1 = __importDefault(require("../constants/row-type"));

var app_1 = __importDefault(require("../constants/app"));

var UtilsColumnGroup = __importStar(require("./column-group"));

var SEARCH_KEY_LABEL_DIVIDER = app_1.default.SEARCH_KEY_LABEL_DIVIDER;

function checkIfPassGlobalSearch(row, query) {
  var isFilterable = getIsFilterable(row);

  if (!isFilterable) {
    return false;
  }

  var queryToColumn = query;

  if (query.includes(SEARCH_KEY_LABEL_DIVIDER)) {
    var labelContent = getLabelContent(row);

    if (!labelContent) {
      return false;
    }

    var index = query.indexOf(SEARCH_KEY_LABEL_DIVIDER);
    var queryLabel = query.slice(0, index);

    if (lodash_1.default.toLower(queryLabel) !== lodash_1.default.toLower(labelContent)) {
      return false;
    } else {
      queryToColumn = query.slice(index + SEARCH_KEY_LABEL_DIVIDER.length);
    }
  }

  if (!queryToColumn) {
    return false;
  }

  var columns = getColumns(row);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var column = _step.value;

      if (UtilsColumn.checkIfPassGlobalSearch(column, queryToColumn)) {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
}

exports.checkIfPassGlobalSearch = checkIfPassGlobalSearch;

function getNewEmptyRow(labelTxt) {
  var defaultKeyValueMap = RowKeyValue.getNewEmptyRow();
  return Object.assign({}, defaultKeyValueMap, {
    uuid: v4_1.default(),
    label: labelTxt ? UtilsLabel.create(labelTxt) : null,
    configs: {
      is_filterable: true
    }
  });
}

exports.getNewEmptyRow = getNewEmptyRow;

function createEmptyRows(labelTxts) {
  var result = [];
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = labelTxts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var labelTxt = _step2.value;
      result.push(getNewEmptyRow(labelTxt));
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return result;
}

exports.createEmptyRows = createEmptyRows;

function createEmptyRowsByStructures(structures) {
  var result = [];
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = structures[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var s = _step3.value;
      result.push(createEmptyRowByStructure(s));
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return result;
}

exports.createEmptyRowsByStructures = createEmptyRowsByStructures;

function createEmptyRowByStructure(structure) {
  var row_title = structure.row_title;
  var defaultKeyValueMap = RowKeyValue.getNewEmptyRowByStructure(structure);
  return Object.assign({}, defaultKeyValueMap, {
    uuid: v4_1.default(),
    label: row_title ? UtilsLabel.create(row_title) : null,
    configs: {
      is_filterable: true
    }
  });
}

exports.createEmptyRowByStructure = createEmptyRowByStructure;

function replaceLabel(row, label) {
  return Object.assign({}, row, {
    label: label
  });
}

exports.replaceLabel = replaceLabel;

function replaceConfigs(row, configs) {
  return Object.assign({}, row, {
    configs: configs
  });
}

exports.replaceConfigs = replaceConfigs;

function getRowsLabels(rows) {
  var result = [];
  lodash_1.default.forEach(rows, function (row, k) {
    if (!!row.label) {
      var ctn = UtilsLabel.getContent(row.label);

      if (!!ctn) {
        result.push(ctn);
      }
    }
  });
  return result;
}

exports.getRowsLabels = getRowsLabels;

function getLabel(row) {
  var label = row.label;

  if (!label) {
    return null;
  }

  var ctn = UtilsLabel.getContent(label);
  return ctn || null;
}

function getRowsLabelsForSort(rows) {
  var result = [];
  lodash_1.default.forEach(rows, function (row, k) {
    if (getIsSortable(row) && !!row.label) {
      var ctn = UtilsLabel.getContent(row.label);

      if (!!ctn) {
        result.push(ctn);
      }
    }
  });
  return result;
}

exports.getRowsLabelsForSort = getRowsLabelsForSort;

function findRowByLabel(rows, targetLabel) {
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = rows[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var row = _step4.value;
      var rowLabelContent = getLabelContent(row);

      if (rowLabelContent === targetLabel) {
        return row;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  return null;
}

exports.findRowByLabel = findRowByLabel;

function getRowsColumns(rows) {
  var result = [];
  lodash_1.default.forEach(rows, function (row, k) {
    var columns = getColumns(row);

    if (lodash_1.default.isArray(columns) && columns.length > 0) {
      result = lodash_1.default.concat(result, columns);
    }
  });
  return result;
}

exports.getRowsColumns = getRowsColumns;

function getRowsColumnsWithSameLabel(rows, label, currentColumn, isDiff) {
  var result = [];
  lodash_1.default.forEach(rows, function (row, k) {
    var curLabel = row.label;

    if (!label || !curLabel) {
      return;
    }

    var columns = getColumns(row);

    if (UtilsLabel.checkSameContent(label, curLabel) && lodash_1.default.isArray(columns)) {
      if (currentColumn !== null && isDiff) {
        result = lodash_1.default.concat(result, RowKeyValue.getDifferentColumns(row, currentColumn));
      } else {
        result = lodash_1.default.concat(result, columns);
      }
    }
  });
  return result;
}

exports.getRowsColumnsWithSameLabel = getRowsColumnsWithSameLabel;

function getFilterData(row) {
  var title = getLabelContent(row);

  if (!title) {
    return [];
  }

  var columns = getColumns(row);
  return columns.reduce(function (acc, cur) {
    var fromColumn = UtilsColumn.getFilterData(cur);

    if (fromColumn === null) {
      return acc;
    }

    return lodash_1.default.concat(acc, {
      meta: _objectSpread({
        label: title
      }, fromColumn.meta),
      input: fromColumn.input
    });
  }, []);
}

exports.getFilterData = getFilterData;

function getSubinfoBySort(row, sortId) {
  var type = row.type,
      label = row.label,
      configs = row.configs;
  var is_filterable = lodash_1.default.get(configs, 'is_filterable', true);

  if (!!label && is_filterable) {
    var columns = getColumns(row);
    var labelTxt = UtilsLabel.getContent(label);

    if (labelTxt === sortId) {
      var firstColumn = getFirstColumn(row);

      if (firstColumn) {
        var subinfoByColumn = UtilsColumn.getSubinfoBySort(firstColumn, sortId);
        return [true, subinfoByColumn];
      } else {
        return [false, null];
      }
    } else {
      return [false, null];
    }
  }

  return [false, null];
}

exports.getSubinfoBySort = getSubinfoBySort;

function extractSearchKeys(rows) {
  var keys = [];
  lodash_1.default.forEach(rows, function (row) {
    var label = row.label;
    var columns = getColumns(row);
    var labelText = label ? UtilsLabel.getContent(label) : null;
    keys = lodash_1.default.concat(keys, UtilsColumn.extractSearchKeys(columns, labelText));
  });
  return lodash_1.default.union(keys);
}

exports.extractSearchKeys = extractSearchKeys;

function getColumns(row) {
  switch (row.type) {
    case row_type_1.default.KEY_VALUE:
      return RowKeyValue.getColumns(row);

    default:
      console.warn("Missing column type");
      return [];
  }
}

exports.getColumns = getColumns;

function getFirstColumn(row) {
  switch (row.type) {
    case row_type_1.default.KEY_VALUE:
      return RowKeyValue.getFirstColumn(row);

    default:
      console.warn("Missing column type");
      return null;
  }
}

exports.getFirstColumn = getFirstColumn;

function getRelatedItemIds(rows, searchLabel) {
  return rows.reduce(function (accu, row) {
    var label = row.label;

    if (label) {
      var labelText = UtilsLabel.getContent(label);

      if (labelText === searchLabel) {
        return lodash_1.default.concat(accu, getRelatedItemIdsOnRow(row));
      }
    }

    return accu;
  }, []);
}

exports.getRelatedItemIds = getRelatedItemIds;

function getRelatedItemIdsOnRow(row) {
  var columns = getColumns(row);
  return UtilsColumn.getRelatedItemIds(columns);
}

function getIsFilterable(row) {
  return lodash_1.default.get(row, 'configs.is_filterable', true);
}

function getIsSortable(row) {
  return lodash_1.default.get(row, 'configs.is_sortable', true);
}

function getLabelContent(row) {
  var label = row.label;
  return label ? UtilsLabel.getContent(label) : null;
}

exports.getLabelContent = getLabelContent;

function getQuickFilterOptions(rows) {
  var result = [];
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    var _loop = function _loop() {
      var row = _step5.value;
      var rowLabel = row.label;

      if (!rowLabel) {
        return "continue";
      }

      var rowTitle = UtilsLabel.getContent(rowLabel);

      if (!rowTitle) {
        return "continue";
      }

      var columns = row.content.columns;

      if (columns.length === 0) {
        return "continue";
      }

      var titles = UtilsColumn.getTitles(columns);

      if (titles.length > 0) {
        titles = lodash_1.default.uniq(titles);
        var opts = titles.map(function (title) {
          return {
            column_title: title,
            row_title: rowTitle
          };
        });
        result = lodash_1.default.concat(result, opts);
      } else {
        result.push({
          column_title: null,
          row_title: rowTitle
        });
      }
    };

    for (var _iterator5 = rows[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var _ret = _loop();

      if (_ret === "continue") continue;
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return result;
}

exports.getQuickFilterOptions = getQuickFilterOptions;

function getQuickFilterOptionContent(rows, option) {
  if (rows.length === 0) {
    return [];
  }

  var result = [];
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = rows[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var row = _step6.value;
      var label = getLabel(row);

      if (label === null) {
        continue;
      }

      if (label === '' || label !== option.row_title) {
        continue;
      }

      var columns = getColumns(row);

      if (columns.length === 0) {
        continue;
      }

      var contents = UtilsColumn.getQuickFilterOptionContent(columns, option);

      if (contents.length > 0) {
        result = lodash_1.default.concat(result, contents);
      }
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  return result;
}

exports.getQuickFilterOptionContent = getQuickFilterOptionContent;

function checkIfSuitQuickFilter(row, query) {
  if (checkIfTitleSuitQuickFilter(row, query)) {
    var columns = getColumns(row);

    if (!lodash_1.default.isArray(columns) || columns.length === 0) {
      return false;
    }

    if (UtilsColumn.checkIfSuitQuickFilter(columns, query)) {
      return true;
    }
  }

  return false;
}

exports.checkIfSuitQuickFilter = checkIfSuitQuickFilter;

function checkIfTitleSuitQuickFilter(row, query) {
  var rowLabel = getLabelContent(row);

  if (!rowLabel) {
    return false;
  }

  var queryTitle = lodash_1.default.get(query, 'option.row_title', null);

  if (rowLabel === queryTitle) {
    return true;
  }

  return false;
}

exports.checkIfTitleSuitQuickFilter = checkIfTitleSuitQuickFilter;

function extractColumnGroups(row) {
  var title = getLabelContent(row);

  if (!title) {
    return [];
  }

  var columns = getColumns(row);
  var groups = columns.reduce(function (acc, column) {
    var columnTitle = UtilsColumn.getLabelContent(column);
    return lodash_1.default.concat(acc, UtilsColumnGroup.create({
      row_title: title,
      column_title: columnTitle
    }));
  }, []);
  return UtilsColumnGroup.deDuplicate(groups);
}

exports.extractColumnGroups = extractColumnGroups;

function getSortComparator(row, columnGroup) {
  var title = getLabelContent(row);

  if (!title) {
    return null;
  }

  var columns = getColumns(row);

  if (lodash_1.default.isArray(columns) && columns.length > 0) {
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = columns[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var column = _step7.value;
        var comparator = UtilsColumn.getSortComparator(column, columnGroup);

        if (comparator !== null) {
          return comparator;
        }
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }
  }

  return null;
}

exports.getSortComparator = getSortComparator;

function getSortInfo(row, columnGroup) {
  var title = getLabelContent(row);

  if (title === null) {
    return null;
  }

  var columns = getColumns(row);
  var _iteratorNormalCompletion8 = true;
  var _didIteratorError8 = false;
  var _iteratorError8 = undefined;

  try {
    for (var _iterator8 = columns[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
      var column = _step8.value;
      var info = UtilsColumn.getSortInfo(column, columnGroup);

      if (info !== null) {
        return info;
      }
    }
  } catch (err) {
    _didIteratorError8 = true;
    _iteratorError8 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
        _iterator8.return();
      }
    } finally {
      if (_didIteratorError8) {
        throw _iteratorError8;
      }
    }
  }

  return null;
}

exports.getSortInfo = getSortInfo;